import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { projectLocationsKeys } from '../locationsKeys'
import { RequestTypes } from '../requestTypes'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useRemoveProjectLocationBoundary = (
  options?: UseMutationOptions<
    unknown,
    RequestErrorType,
    RequestTypes['removeProjectLocationBoundary']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...projectLocationsKeys.removeProjectLocationBoundary,
    ...options,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: projectLocationsKeys._def })
      options?.onSuccess?.(...args)
    },
  })
}
